import React, { useState, useCallback } from 'react';

import { useIncode } from '../../hooks/use-incode';
import useUserContext from '../../hooks/useUserContext';
import { Modal } from '../Cashouts/components/modal/modal';
import { VerifyIdentity, needsIdentityVerification } from '../Cashouts/components/verify-identity';

import { Iconify } from '../../Xmerald-UI';
import { Box, CallToAction, VerifiedAccount } from './components/styled';

export const VerificationTrigger = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userData } = useUserContext();
  const { incodeEnabled } = useIncode();

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  if (!incodeEnabled) return null;

  const needsVerification = needsIdentityVerification(userData, incodeEnabled);

  if (!needsVerification && !isModalOpen) {
    return (
      <VerifiedAccount>
        <Iconify icon="ic:baseline-verified" size={16} />
        <span>Cuenta verificada</span>
      </VerifiedAccount>
    );
  }

  return (
    <>
      <Modal
        showModal={isModalOpen}
        onClose={handleCloseModal}
        title="Verificar cuenta"
      >
        <VerifyIdentity onSuccess={handleCloseModal} />
      </Modal>

      {needsVerification && (
        <CallToAction action={() => setIsModalOpen(true)}>
          <div className="flex-col">
            <Box>
              <Iconify icon="ic:baseline-verified" size={16} />
              <span>Verificar mi cuenta</span>
            </Box>
          </div>
        </CallToAction>
      )}
    </>
  );
};
